import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components
// core components
export default function CardCreditDetails() {
  const theme = useTheme();
  return (
    <>
      {
        <Card
          sx={{
            background:
              "linear-gradient(87deg," +
              theme.palette.dark.main +
              ",#1a174d)!important",
          }}
        >
          <CardContent>
            <Box sx={{ marginBottom: ".5rem" }}>
              <Box
                component="sup"
                sx={{
                  color: theme.palette.white.main,
                  position: "relative",
                  fontSize: "75%",
                  lineHeight: "0",
                  marginRight: ".25rem",
                }}
              >
                $
              </Box>
              <Typography
                variant="h2"
                component="span"
                sx={{ color: theme.palette.white.main }}
              >
                3,300
              </Typography>
              <Box
                color={theme.palette.gray[400]}
                sx={{ fontSize: ".875rem", marginTop: ".5rem" }}
              >
                Your current balance
              </Box>
              <div>
                <Box
                  component="span"
                  sx={{
                    color: theme.palette.success.main,
                    marginRight: ".5rem",
                  }}
                >
                  + 15%
                </Box>
                <Box component="span" sx={{ color: theme.palette.gray[400] }}>
                  ($250)
                </Box>
              </div>
            </Box>
            <Button size="small" fullWidth variant="neutral">
              Add credit
            </Button>
          </CardContent>
          <CardContent>
            <Grid container>
              <Grid item xs={6}>
                <Box
                  component="small"
                  sx={{
                    color: theme.palette.gray[400],
                    fontSize: "80%",
                    fontWeight: "400",
                  }}
                >
                  Orders: 60%
                </Box>
                <Box sx={{ width: "100%" }}>
                  <LinearProgress
                    variant="determinate"
                    value={60}
                    sx={{
                      height: "3px!important",
                      margin: ".5rem 0!important",
                      "& .MuiLinearProgress-bar": {
                        background: theme.palette.success.main,
                      },
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  component="small"
                  sx={{
                    color: theme.palette.gray[400],
                    fontSize: "80%",
                    fontWeight: "400",
                  }}
                >
                  Sales: 40%
                </Box>
                <LinearProgress
                  variant="determinate"
                  value={40}
                  sx={{
                    height: "3px!important",
                    margin: ".5rem 0!important",
                    "& .MuiLinearProgress-bar": {
                      background: theme.palette.warning.main,
                    },
                  }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      }
    </>
  );
}
